import { Language } from "../../utils/data/Languages";

export type HelpLanguage = Language;

export interface HelpItemTranslation {
    lang: HelpLanguage;
    title: string;
    teaser: string;
    body: string;
    examples: string;
    references: string;
}

export const emptyHelpItemTranslation: HelpItemTranslation = {
    lang: 'en',
    title: '',
    teaser: '',
    body: '',
    examples: '',
    references: ''
}

export interface HelpItem {
    _id: string;
    defaultLang: HelpLanguage;
    translations: HelpItemTranslation[];
}

export const emptyHelpItem: HelpItem = {
    _id: '',
    defaultLang: 'en',
    translations: [
        {
            lang: 'en',
            title: '',
            teaser: '',
            body: '',
            examples: '',
            references: ''
        }
    ]
}

export interface Help {
    _id: string;
    name: string;
    items: HelpItem[];
    weight: number;
}

export const emptyHelp: Help = {
    _id: '',
    name: '',
    items: [],
    weight: 0
}
